import React, { useState } from 'react'

export const useMenuContacts = () => {

    const [EstadoMenu, setEstadoMenu] = useState(true)
    const [ClassContentMimensajes, setClassContentMimensajes] = useState("contentMiMensajes")

    const closeMenuContacts = () => {
        if (EstadoMenu === true) {
            setClassContentMimensajes("contentMiMensajesNoMenuContacts")
        } else {
            setClassContentMimensajes("contentMiMensajes")
        }
        setEstadoMenu(!EstadoMenu)
    }
    return {
        EstadoMenu: EstadoMenu,
        ClassContentMimensajes: ClassContentMimensajes,
        closeMenuContacts: closeMenuContacts,
    }
}
